import { useContext } from 'react';
import { Button, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../../context/GlobalContext';

import './SubsidyErrorModal.scss';

interface Props {
    id: string;
    title: string;
    description: string;
    firstButtonText: string;
    secButtonText?: string;
    modalFirstButtonClick: () => void;
    modalSecondButtonClick?: () => void;
}

function SubsidyErrorModal({ id, title, description, firstButtonText, secButtonText, modalFirstButtonClick, modalSecondButtonClick }: Props) {

    const { state }: any = useContext(GlobalContext);
    const { rtl } = state;

    return (
        <div className={rtl ? 'SubsidyError__ModalContainer SubsidyError__ModalRight' : 'SubsidyError__ModalContainer'}>
            <div className='SubsidyError__Fallback'></div>
            <div className='SubsidyError__Modal' id={id}>
                <Typography rtl={rtl} className='SubsidyError__MT'>{title}</Typography>
                <Typography rtl={rtl} className='SubsidyError__MST'>{description}</Typography>

                <Button rtl={rtl} className='SubsidyError__MButton' onClick={modalFirstButtonClick}>{firstButtonText}</Button>
                {secButtonText && <Button rtl={rtl} className='SubsidyError__MButton SubsidyError__SecButton' onClick={modalSecondButtonClick}>{secButtonText}</Button>}
            </div>
        </div>
    )
}

export default SubsidyErrorModal